/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Detail_No_Associated_ClientsInputs */

const en_users_detail_no_associated_clients = /** @type {(inputs: Users_Detail_No_Associated_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No associated clients.`)
};

const pt_br2_users_detail_no_associated_clients = /** @type {(inputs: Users_Detail_No_Associated_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum cliente associado.`)
};

/**
* | output |
* | --- |
* | "No associated clients." |
*
* @param {Users_Detail_No_Associated_ClientsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_detail_no_associated_clients = /** @type {((inputs?: Users_Detail_No_Associated_ClientsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Detail_No_Associated_ClientsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_detail_no_associated_clients(inputs)
	return pt_br2_users_detail_no_associated_clients(inputs)
});